<template>
  <v-sheet
    id="integration-marketplace-placeholder"
    elevation="2"
    class="rounded white pa-0"
    height="696"
  />
</template>

<script>
import { mapActions } from 'vuex'
import prismatic, { PrismaticMessageEvent } from '@prismatic-io/embedded'
import api from '@/api'

export default {
  name: 'Integrations',

  props: {
    organizationId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    apiKey: {
      _id: null,
      APIKey: null,
    },
  }),

  created() {
    prismatic.init({
      fontConfiguration: {
        google: {
          families: ['Inter'],
        },
      },
      screenConfiguration: {
        initializing: {
          background: '#FFFFFF',
          color: 'rgba(0, 0, 0, 0.87)',
        },
        marketplace: {
          hideSearch: true,
          hideActiveIntegrationsFilter: true,
          includeActiveIntegrations: true,
        },
      },
    })
  },

  mounted() {
    this.embedIntegrationsMarketplace()

    window.addEventListener('message', this.initializePrismatic)
  },

  beforeDestroy() {
    window.removeEventListener('message', this.initializePrismatic)
  },

  methods: {
    ...mapActions({
      createAPIKey: 'createAPIKey',
      deleteAPIKey: 'deleteAPIKey',
    }),

    async initializePrismatic(event) {
      if (event.data.event === PrismaticMessageEvent.INSTANCE_CREATED) {
        console.log('INSTANCE_CREATED', event.data)

        const response = await this.createAPIKey({
          organizationId: this.organizationId,
          name: `${event.data.data.instanceName} - ${event.data.data.instanceId}`,
          applicationAccount: this.$store.getters.account._id,
          createdByIntegration: true,
          source: 'integration',
        })

        this.apiKey = {
          _id: response.data._id,
          APIKey: response.data.APIKey,
        }

        console.log(`API Key created with id ${this.apiKey._id}`, response.data)
      }

      if (
        event.data.event === PrismaticMessageEvent.INSTANCE_CONFIGURATION_LOADED
      ) {
        console.log('INSTANCE_CONFIGURATION_LOADED', event.data)
        prismatic.setConfigVars({
          selector: '#integration-marketplace-placeholder',
          configVars: {
            'Rever Connection': {
              inputs: {
                apiKey: { value: this.apiKey.APIKey },
                apiId: { value: this.apiKey._id },
                organizationId: { value: this.organizationId },
              },
            },
          },
        })
      }

      if (event.data.event === PrismaticMessageEvent.INSTANCE_DELETED) {
        console.log('INSTANCE_DELETED', event.data)

        if (this.apiKey._id) {
          await this.deleteAPIKey({
            organizationId: this.organizationId,
            apiKeyId: this.apiKey._id,
          })

          console.log(`Removed API Key with id ${this.apiKey._id}`)
        }
      }
    },

    async embedIntegrationsMarketplace() {
      try {
        const { data } = await api.account.prismaticAuth()
        await prismatic.authenticate({ token: data.token })

        prismatic.showMarketplace({
          selector: '#integration-marketplace-placeholder',
          usePopover: false,
          theming: 'LIGHT',
        })
      } catch (error) {
        console.error('Error embedding Prismatic marketplace:', error)
      }
    },
  },
}
</script>
